/* eslint-disable */
import request from './helpers'

export function updateColdBackup (data) {
    return request ({
        url: '/api/v1/cluster/update/cold/backup',
        method: 'post',
        headers: {
          'Content-Type': 'application/json'
        },
        data
    })
}

export function updateHotBackup (data) {
    return request ({
        url: '/api/v1/cluster/update/hot/backup',
        method: 'post',
        headers: {
          'Content-Type': 'application/json'
        },
        data
    })
}

export function listColdBackup (dcName) {
    return request ({
        url: '/api/v1/cluster/list/dc/cold/backup',
        method: 'get',
        params: {
            dcName
        }
    })
}

export function listHotBackup (channelName, dcName) {
    return request ({
        url: '/api/v1/cluster/list/hot/backup',
        method: 'get',
        params: {
            channelName, dcName
        }
    })
}

export function uploadFromKafka (data) {
    return request ({
        url: '/api/v1/cluster/upload_from_kafka_manage',
        method: 'post',
        headers: {
            'Content-Type': 'application/json'
        },
        data: {
            uploadClusterFromKafkaManageParams: data
        }
    })
}
